export default "__VITE_ASSET___H2jXrhG__"